export const ONE_HOUR_IN_SECONDS = 60 * 60;
export const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS * 24;
export const ONE_WEEK_IN_MS = 7 * ONE_DAY_IN_SECONDS * 1000;
export const ONE_YEAR_IN_SECONDS = ONE_DAY_IN_SECONDS * 365;
export const ONE_MONTH_MS = 1000 * 60 * 60 * 24 * 30;

export const ONE_MINUTE_MS = 1000 * 60;
export const ONE_HOUR_MS = 1000 * 60 * 60;
